/**************************************************
 * Nombre:       Detalle_Sos_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {formatoFecha} from "../../../Utilidades/formatoFecha";
import {irAtras} from "../../../Utilidades/irAtras";
import {ArrowBackIos} from "@mui/icons-material";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Detalle_Sos_Portada = ({item}) => {
    const {sCell} = useResponsive()


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 18}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{maxWidth: '1400px', px: 3}}
                        spacing={4}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? -8 : -7, ml: sCell ? -6 : -10}}>
                            <Button
                                onClick={() => irAtras()}
                                variant={'text'} startIcon={<ArrowBackIos/>}>Atras</Button>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 5, md: 5}} sx={{justifyContent: 'flex-start', mt: -5}}>
                            <img src={item.img} width={'100%'} height={'auto'} style={{borderRadius: 10}}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 7, md: 7}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={1}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{color: theme.palette.primary.main, fontSize: 15, fontWeight: 600}}>
                                        {formatoFecha(item.fecha)}
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 20, fontWeight: 600}}>
                                        {item.nombre}
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 400}}>
                                        {item.descripcion}
                                    </Typography>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 16, fontWeight: 400}}>
                                {item.descripcionDos}
                            </Typography>
                        </Grid>


                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Detalle_Sos_Portada